import * as React from 'react';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import { isBranchAdmin } from '@bb/users';
import AnnouncementListView from './AnnouncementListView';
import AnnouncementEditView from './AnnouncementEditView';

/**
 * @deprecated This component is being deprecated under the "removeAngularFeature" flag.
 * Routes have been moved to [Router/pages/AnnouncementPages].
 */
const AnnouncementRouter = (props: any) => {
  const {
    $rootScope: { auth },
  } = props;

  const { email: userEmail, roles, role, location, locations } = auth;

  const authorizedLocations = isBranchAdmin(auth)
    ? new Set([location, ...(locations || [])])
    : undefined;

  return roles[role] >= roles.BRANCH_ADMIN ? (
    <BrowserRouter basename="/#/announcement">
      <Switch>
        <Route exact path="/list" component={AnnouncementListView} />
        <Route
          exact
          path="/new"
          render={routeProps => (
            <AnnouncementEditView
              {...routeProps}
              userEmail={userEmail}
              authorizedLocations={authorizedLocations}
            />
          )}
        />
        <Route
          exact
          path="/:announcementId/edit"
          render={routeProps => (
            <AnnouncementEditView
              {...routeProps}
              userEmail={userEmail}
              authorizedLocations={authorizedLocations}
            />
          )}
        />
      </Switch>
    </BrowserRouter>
  ) : (
    <div>You are not authorized to access this page.</div>
  );
};

export default AnnouncementRouter;
